import type React from 'react'
import { useEffect, useState } from 'react'

import { parseVersionString } from 'utils/version-string/version-string'
// prettier-ignore
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'shadcdn/ui/alert-dialog'
import { CONFIG } from 'config'
import { appAPI } from 'utils/app-api'

type Props = {
  children: React.ReactNode
}

export const UpdateRequiredOverlay = (props: Props) => {
  const updateRequired = useUpdateRequired()

  return (
    <>
      <AlertDialog open={updateRequired}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Update required</AlertDialogTitle>
            <AlertDialogDescription className="pb-3">
              Please wait while we update the app to the latest version or download the latest version from the website{' '}
              <a href="https://presync.io" target="_blank" className="link" rel="noopener">
                https://presync.io
              </a>
            </AlertDialogDescription>
            <AlertDialogFooter>
              <AlertDialogAction className="mx-auto" asChild={true}>
                <a href="https://presync.io" target="_blank" rel="noopener">
                  Open https://presync.io
                </a>
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogHeader>
        </AlertDialogContent>
      </AlertDialog>

      {props.children}
    </>
  )
}

function useUpdateRequired() {
  const [appVersion, setAppVersion] = useState<Array<string | unknown> | undefined>(undefined)
  useEffect(() => {
    appAPI.getAppVersion().then((v) => {
      if (v === 'PRESYNC_IN_BROWSER') return
      setAppVersion(parseVersionString(v))
    })
  }, [])
  if (!CONFIG.FRONTEND_VERSION) return false
  const frontVersion = parseVersionString(CONFIG.FRONTEND_VERSION)

  if (!appVersion) return false
  return frontVersion.slice(0, 2) > appVersion.slice(0, 2)
}
